import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { Quasar } from 'quasar'
import quasarUserOptions from './quasar-user-options'
import useAuth from './store/auth.store'
import { i18n } from './i18n'

const app = createApp(App)
const auth = useAuth()

const baseComponents = import.meta.globEager('./components/base/*.vue')
Object.entries(baseComponents).forEach(([path, definition]) => {
  const componentName = path.split('/').pop().replace(/\.\w+$/, '')
  app.component(componentName, definition.default)
})

app.use(i18n)
auth
  .checkAuthentication()
  .then(() => {
      app.use(router)
      app.use(Quasar, quasarUserOptions)
      app.mount('#app')
    })